// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/stylesheet.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 10 6%27%3e %3cpath stroke=%27%236B7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m1 1 4 4 4-4%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M1 5.917 5.724 10.5 15 1.5%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M0.5 6h14%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Lato", "Roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.stylish-scroll::-webkit-scrollbar {
  width: 5px;
}

.stylish-scroll::-webkit-scrollbar-track {
  background-color: transparent !important;
  border-radius: 100px;
}

.stylish-scroll::-webkit-scrollbar-thumb {
  border-radius: 100px;
  border: 5px solid transparent;
  background-clip: content-box;
  background: rgba(129, 56, 223, 0.2);
}

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(63 131 248 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(63 131 248 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E5E7EB; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9CA3AF; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before{
  border-style: solid;
  border-color: #e5e7eb;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before{
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before{
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before{
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before{
  border-top-width: 1px;
  border-right-width: 1px;
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow{
  bottom: -4px;
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow{
  top: -4px;
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow{
  right: -4px;
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow{
  left: -4px;
}

.tooltip.invisible > .tooltip-arrow:before{
  visibility: hidden;
}

[data-popper-arrow],[data-popper-arrow]:before{
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

[data-popper-arrow]{
  visibility: hidden;
}

[data-popper-arrow]:before{
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-popper-arrow]:after{
  content: "";
  visibility: visible;
  transform: rotate(45deg);
  position: absolute;
  width: 9px;
  height: 9px;
  background: inherit;
}

[role="tooltip"] > [data-popper-arrow]:before{
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:before{
  border-style: solid;
  border-color: #4b5563;
}

[role="tooltip"] > [data-popper-arrow]:after{
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:after{
  border-style: solid;
  border-color: #4b5563;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before{
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after{
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before{
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after{
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before{
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after{
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before{
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after{
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]{
  bottom: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]{
  top: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]{
  right: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]{
  left: -5px;
}

[role="tooltip"].invisible > [data-popper-arrow]:before{
  visibility: hidden;
}

[role="tooltip"].invisible > [data-popper-arrow]:after{
  visibility: hidden;
}

[type='text'],[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select{
  appearance: none;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #1C64F2;
}

input::placeholder,textarea::placeholder{
  color: #6B7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper{
  padding: 0;
}

input[type="time"]::-webkit-calendar-picker-indicator{
  background: none;
}

select:not([size]){
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 0.75em 0.75em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

:is([dir=rtl]) select:not([size]){
  background-position: left 0.75rem center;
  padding-right: 0.75rem;
  padding-left: 0;
}

[multiple]{
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
          print-color-adjust: unset;
}

[type='checkbox'],[type='radio']{
  appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #1C64F2;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox']{
  border-radius: 0px;
}

[type='radio']{
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked,.dark [type='checkbox']:checked,.dark [type='radio']:checked{
  border-color: transparent;
  background-color: currentColor;
  background-size: 0.55em 0.55em;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='radio']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

.dark [type='radio']:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

[type='checkbox']:indeterminate{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: currentColor;
  border-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus{
  border-color: transparent;
  background-color: currentColor;
}

[type='file']{
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus{
  outline: 1px auto inherit;
}

input[type=file]::file-selector-button{
  color: white;
  background: #1F2937;
  border: 0;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 2rem;
  padding-right: 1rem;
  margin-inline-start: -1rem;
  margin-inline-end: 1rem;
}

input[type=file]::file-selector-button:hover{
  background: #374151;
}

:is([dir=rtl]) input[type=file]::file-selector-button{
  padding-right: 2rem;
  padding-left: 1rem;
}

.dark input[type=file]::file-selector-button{
  color: white;
  background: #4B5563;
}

.dark input[type=file]::file-selector-button:hover{
  background: #6B7280;
}

input[type="range"]::-webkit-slider-thumb{
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-webkit-slider-thumb{
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-webkit-slider-thumb{
  background: #6B7280;
}

input[type="range"]:focus::-webkit-slider-thumb{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1px;
  --tw-ring-color: rgb(164 202 254 / var(--tw-ring-opacity));
}

input[type="range"]::-moz-range-thumb{
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-moz-range-thumb{
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-moz-range-thumb{
  background: #6B7280;
}

input[type="range"]::-moz-range-progress{
  background: #3F83F8;
}

input[type="range"]::-ms-fill-lower{
  background: #3F83F8;
}

input[type="range"].range-sm::-webkit-slider-thumb{
  height: 1rem;
  width: 1rem;
}

input[type="range"].range-lg::-webkit-slider-thumb{
  height: 1.5rem;
  width: 1.5rem;
}

input[type="range"].range-sm::-moz-range-thumb{
  height: 1rem;
  width: 1rem;
}

input[type="range"].range-lg::-moz-range-thumb{
  height: 1.5rem;
  width: 1.5rem;
}

.toggle-bg:after{
  content: "";
  position: absolute;
  top: 0.125rem;
  left: 0.125rem;
  background: white;
  border-color: #D1D5DB;
  border-width: 1px;
  border-radius: 9999px;
  height: 1.25rem;
  width: 1.25rem;
  transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;
  transition-duration: .15s;
  box-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
}

input:checked + .toggle-bg:after{
  transform: translateX(100%);;
  border-color: white;
}

input:checked + .toggle-bg{
  background: #1C64F2;
  border-color: #1C64F2;
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 560px){
  .\\!container{
    max-width: 560px !important;
  }
  .container{
    max-width: 560px;
  }
}
@media (min-width: 767px){
  .\\!container{
    max-width: 767px !important;
  }
  .container{
    max-width: 767px;
  }
}
@media (min-width: 1024px){
  .\\!container{
    max-width: 1024px !important;
  }
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1200px){
  .\\!container{
    max-width: 1200px !important;
  }
  .container{
    max-width: 1200px;
  }
}
@media (min-width: 1440px){
  .\\!container{
    max-width: 1440px !important;
  }
  .container{
    max-width: 1440px;
  }
}
@media (min-width: 1536px){
  .\\!container{
    max-width: 1536px !important;
  }
  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-1{
  bottom: -0.25rem;
}
.-left-1{
  left: -0.25rem;
}
.-left-1\\.5{
  left: -0.375rem;
}
.-left-3{
  left: -0.75rem;
}
.-right-1{
  right: -0.25rem;
}
.-right-10{
  right: -2.5rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-10{
  top: -2.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-\\[1\\.4rem\\]{
  bottom: 1.4rem;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-5{
  left: 1.25rem;
}
.left-6{
  left: 1.5rem;
}
.right-0{
  right: 0px;
}
.right-0\\.5{
  right: 0.125rem;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-5{
  right: 1.25rem;
}
.right-\\[-60px\\]{
  right: -60px;
}
.right-\\[13px\\]{
  right: 13px;
}
.right-\\[3rem\\]{
  right: 3rem;
}
.top-0{
  top: 0px;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-12{
  top: 3rem;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-\\[12px\\]{
  top: 12px;
}
.top-\\[20px\\]{
  top: 20px;
}
.top-\\[24px\\]{
  top: 24px;
}
.top-\\[42\\%\\]{
  top: 42%;
}
.-z-10{
  z-index: -10;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-auto{
  z-index: auto;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.\\!m-0{
  margin: 0px !important;
}
.m-0{
  margin: 0px;
}
.-mx-1\\.5{
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-my-1\\.5{
  margin-top: -0.375rem;
  margin-bottom: -0.375rem;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mr-16{
  margin-right: -4rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-2\\.5{
  margin-top: -0.625rem;
}
.-mt-\\[46px\\]{
  margin-top: -46px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.me-4{
  margin-inline-end: 1rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-2\\.5{
  margin-right: 0.625rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-11{
  margin-top: 2.75rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-3\\.5{
  margin-top: 0.875rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[47px\\]{
  margin-top: 47px;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.\\!inline{
  display: inline !important;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.\\!h-10{
  height: 2.5rem !important;
}
.\\!h-11{
  height: 2.75rem !important;
}
.\\!h-9{
  height: 2.25rem !important;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[115px\\]{
  height: 115px;
}
.h-\\[185px\\]{
  height: 185px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-lvh{
  height: 100lvh;
}
.h-modal{
  height: calc(100% - 2rem);
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-\\[90dvh\\]{
  max-height: 90dvh;
}
.\\!w-\\[10rem\\]{
  width: 10rem !important;
}
.\\!w-\\[9rem\\]{
  width: 9rem !important;
}
.\\!w-full{
  width: 100% !important;
}
.w-1\\/2{
  width: 50%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\/4{
  width: 50%;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[25\\%\\]{
  width: 25%;
}
.w-\\[25px\\]{
  width: 25px;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[75\\%\\]{
  width: 75%;
}
.w-\\[75px\\]{
  width: 75px;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.min-w-0{
  min-width: 0px;
}
.min-w-32{
  min-width: 8rem;
}
.min-w-\\[359px\\]{
  min-width: 359px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[100vw\\]{
  max-width: 100vw;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[45\\%\\]{
  max-width: 45%;
}
.max-w-\\[75\\%\\]{
  max-width: 75%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-auto{
  flex: 1 1 auto;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.origin-\\[0\\]{
  transform-origin: 0;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-4{
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-6{
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75{
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-wait{
  cursor: wait;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.snap-x{
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory{
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center{
  scroll-snap-align: center;
}
.list-inside{
  list-style-position: inside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-flow-col{
  grid-auto-flow: column;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.content-between{
  align-content: space-between;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-x-0{
  column-gap: 0px;
}
.gap-x-1{
  column-gap: 0.25rem;
}
.gap-x-1\\.5{
  column-gap: 0.375rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-y-8{
  row-gap: 2rem;
}
.-space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-1rem * var(--tw-space-x-reverse));
  margin-left: calc(-1rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-px > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.\\!overflow-x-hidden{
  overflow-x: hidden !important;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-hidden{
  overflow-y: hidden;
}
.overflow-x-scroll{
  overflow-x: scroll;
}
.\\!scroll-auto{
  scroll-behavior: auto !important;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[3px\\]{
  border-radius: 3px;
}
.rounded-\\[5px\\]{
  border-radius: 5px;
}
.rounded-\\[7px\\]{
  border-radius: 7px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-b{
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-e-lg{
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.rounded-l-lg{
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-none{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-lg{
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-none{
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-s-lg{
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-bl-full{
  border-bottom-left-radius: 9999px;
}
.rounded-tl-full{
  border-top-left-radius: 9999px;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-8{
  border-width: 8px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-0{
  border-left-width: 0px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-r-0{
  border-right-width: 0px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-t-4{
  border-top-width: 4px;
}
.border-solid{
  border-style: solid;
}
.border-\\[\\#10B981\\]{
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1c1c2c\\]{
  --tw-border-opacity: 1;
  border-color: rgb(28 28 44 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8138df66\\]{
  border-color: #8138df66;
}
.border-\\[\\#8138df\\]{
  --tw-border-opacity: 1;
  border-color: rgb(129 56 223 / var(--tw-border-opacity, 1));
}
.border-\\[\\#84848c\\]{
  --tw-border-opacity: 1;
  border-color: rgb(132 132 140 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cf202f\\]{
  --tw-border-opacity: 1;
  border-color: rgb(207 32 47 / var(--tw-border-opacity, 1));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity, 1));
}
.border-cyan-300{
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}
.border-cyan-500{
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.border-cyan-600{
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity, 1));
}
.border-cyan-700{
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-800{
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-gray-900{
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(132 225 188 / var(--tw-border-opacity, 1));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}
.border-green-600{
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity, 1));
}
.border-green-700{
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity, 1));
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(205 219 254 / var(--tw-border-opacity, 1));
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(180 198 252 / var(--tw-border-opacity, 1));
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(141 162 251 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity, 1));
}
.border-lime-300{
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / var(--tw-border-opacity, 1));
}
.border-lime-400{
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / var(--tw-border-opacity, 1));
}
.border-lime-500{
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity, 1));
}
.border-neutral-300{
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity, 1));
}
.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity, 1));
}
.border-pink-300{
  --tw-border-opacity: 1;
  border-color: rgb(248 180 217 / var(--tw-border-opacity, 1));
}
.border-pink-500{
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity, 1));
}
.border-pink-600{
  --tw-border-opacity: 1;
  border-color: rgb(214 31 105 / var(--tw-border-opacity, 1));
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity, 1));
}
.border-purple-900{
  --tw-border-opacity: 1;
  border-color: rgb(74 29 150 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(248 180 180 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}
.border-red-600{
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity, 1));
}
.border-red-900{
  --tw-border-opacity: 1;
  border-color: rgb(119 29 29 / var(--tw-border-opacity, 1));
}
.border-sky-500{
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity, 1));
}
.border-teal-300{
  --tw-border-opacity: 1;
  border-color: rgb(126 220 226 / var(--tw-border-opacity, 1));
}
.border-teal-500{
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(250 202 21 / var(--tw-border-opacity, 1));
}
.border-yellow-400{
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity, 1));
}
.border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity, 1));
}
.border-yellow-600{
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity, 1));
}
.border-l-indigo-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(104 117 245 / var(--tw-border-opacity, 1));
}
.border-opacity-0{
  --tw-border-opacity: 0;
}
.border-opacity-25{
  --tw-border-opacity: 0.25;
}
.\\!bg-\\[\\#e63737\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(230 55 55 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-gray-50{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent{
  background-color: transparent !important;
}
.\\!bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3) !important;
}
.bg-\\[\\#0EA5E91a\\]{
  background-color: #0EA5E91a;
}
.bg-\\[\\#0EA5E9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0ea5e91a\\]{
  background-color: #0ea5e91a;
}
.bg-\\[\\#10B981\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#10b9811a\\]{
  background-color: #10b9811a;
}
.bg-\\[\\#1B1C1E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(27 28 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c1c2c\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 44 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#245501\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(36 85 1 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2E5528\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(46 85 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2e5528\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(46 85 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#43ff64d9\\]{
  background-color: #43ff64d9;
}
.bg-\\[\\#808b9a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(128 139 154 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8138df0d\\]{
  background-color: #8138df0d;
}
.bg-\\[\\#8346d48e\\]{
  background-color: #8346d48e;
}
.bg-\\[\\#9358e031\\]{
  background-color: #9358e031;
}
.bg-\\[\\#D85564\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(216 85 100 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F4F4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F97316\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d85564\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(216 85 100 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f4f4\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f8f8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f973161a\\]{
  background-color: #f973161a;
}
.bg-\\[\\]{
  background-color: ;
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(225 239 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(28 100 242 / var(--tw-bg-opacity, 1));
}
.bg-blue-700{
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity, 1));
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-200{
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-cyan-600{
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-cyan-700{
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 141 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(243 250 247 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity, 1));
}
.bg-green-700{
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400{
  --tw-bg-opacity: 1;
  background-color: rgb(141 162 251 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity, 1));
}
.bg-lime-100{
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity, 1));
}
.bg-lime-400{
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / var(--tw-bg-opacity, 1));
}
.bg-lime-600{
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity, 1));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(231 70 148 / var(--tw-bg-opacity, 1));
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 105 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 235 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(246 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity, 1));
}
.bg-purple-700{
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(249 128 128 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(224 36 36 / var(--tw-bg-opacity, 1));
}
.bg-red-700{
  --tw-bg-opacity: 1;
  background-color: rgb(200 30 30 / var(--tw-bg-opacity, 1));
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity, 1));
}
.bg-teal-600{
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400{
  --tw-bg-opacity: 1;
  background-color: rgb(227 160 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 234 / var(--tw-bg-opacity, 1));
}
.bg-yellow-600{
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity, 1));
}
.bg-opacity-0{
  --tw-bg-opacity: 0;
}
.bg-opacity-25{
  --tw-bg-opacity: 0.25;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-cyan-400{
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500{
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400{
  --tw-gradient-from: #31C48D var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 196 141 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-200{
  --tw-gradient-from: #d9f99d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 249 157 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-400{
  --tw-gradient-from: #F17EB8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 126 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500{
  --tw-gradient-from: #E74694 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(231 70 148 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: #9061F9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(144 97 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #7E3AF2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 58 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-200{
  --tw-gradient-from: #FBD5D5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 213 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400{
  --tw-gradient-from: #F98080 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 128 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-200{
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400{
  --tw-gradient-from: #16BDCA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 189 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-cyan-500{
  --tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #06b6d4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-600{
  --tw-gradient-to: rgb(8 145 178 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0891b2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-green-500{
  --tw-gradient-to: rgb(14 159 110 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0E9F6E var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-lime-400{
  --tw-gradient-to: rgb(163 230 53 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a3e635 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500{
  --tw-gradient-to: rgb(231 70 148 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E74694 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-600{
  --tw-gradient-to: rgb(126 58 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #7E3AF2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-300{
  --tw-gradient-to: rgb(248 180 180 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F8B4B4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-500{
  --tw-gradient-to: rgb(240 82 82 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F05252 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500{
  --tw-gradient-to: rgb(6 148 162 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0694A2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-cyan-500{
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-600{
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-cyan-700{
  --tw-gradient-to: #0e7490 var(--tw-gradient-to-position);
}
.to-green-600{
  --tw-gradient-to: #057A55 var(--tw-gradient-to-position);
}
.to-lime-200{
  --tw-gradient-to: #d9f99d var(--tw-gradient-to-position);
}
.to-lime-500{
  --tw-gradient-to: #84cc16 var(--tw-gradient-to-position);
}
.to-orange-400{
  --tw-gradient-to: #FF8A4C var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #E74694 var(--tw-gradient-to-position);
}
.to-pink-600{
  --tw-gradient-to: #D61F69 var(--tw-gradient-to-position);
}
.to-purple-700{
  --tw-gradient-to: #6C2BD9 var(--tw-gradient-to-position);
}
.to-red-600{
  --tw-gradient-to: #E02424 var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: #047481 var(--tw-gradient-to-position);
}
.to-yellow-200{
  --tw-gradient-to: #FCE96A var(--tw-gradient-to-position);
}
.bg-clip-padding{
  background-clip: padding-box;
}
.fill-\\[\\#10B981\\]{
  fill: #10B981;
}
.fill-\\[\\#F97316\\]{
  fill: #F97316;
}
.fill-current{
  fill: currentColor;
}
.fill-cyan-600{
  fill: #0891b2;
}
.fill-gray-600{
  fill: #4B5563;
}
.fill-green-500{
  fill: #0E9F6E;
}
.fill-pink-600{
  fill: #D61F69;
}
.fill-purple-600{
  fill: #7E3AF2;
}
.fill-red-600{
  fill: #E02424;
}
.fill-yellow-400{
  fill: #E3A008;
}
.object-cover{
  object-fit: cover;
}
.\\!p-0{
  padding: 0px !important;
}
.\\!p-2\\.5{
  padding: 0.625rem !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-\\[6px\\]{
  padding: 6px;
}
.p-\\[7px\\]{
  padding: 7px;
}
.\\!px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-\\[0\\.32rem\\]{
  padding-top: 0.32rem;
  padding-bottom: 0.32rem;
}
.py-\\[40px\\]{
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-\\[6px\\]{
  padding-top: 6px;
  padding-bottom: 6px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-0{
  padding-left: 0px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-16{
  padding-left: 4rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-20{
  padding-left: 5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-8{
  padding-right: 2rem;
}
.pr-\\[75px\\]{
  padding-right: 75px;
}
.ps-5{
  padding-inline-start: 1.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.align-middle{
  vertical-align: middle;
}
.font-manrope{
  font-family: Manrope, sans-serif;
}
.\\!text-base{
  font-size: 1rem !important;
  line-height: 1.5rem !important;
}
.\\!text-sm{
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-9{
  line-height: 2.25rem;
}
.leading-none{
  line-height: 1;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.text-\\[\\#0EA5E9\\]{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-\\[\\#10B981\\]{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1B1C1E\\]{
  --tw-text-opacity: 1;
  color: rgb(27 28 30 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1c1c2c\\]{
  --tw-text-opacity: 1;
  color: rgb(28 28 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#245501\\]{
  --tw-text-opacity: 1;
  color: rgb(36 85 1 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3339\\]{
  color: #3339;
}
.text-\\[\\#D85564\\]{
  --tw-text-opacity: 1;
  color: rgb(216 85 100 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F97316\\]{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-\\[\\]{
  color: ;
}
.text-\\[red\\]{
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(26 86 219 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 66 159 / var(--tw-text-opacity, 1));
}
.text-cyan-300{
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.text-cyan-500{
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-cyan-800{
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-cyan-900{
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(4 108 78 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity, 1));
}
.text-green-900{
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity, 1));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(104 117 245 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(81 69 205 / var(--tw-text-opacity, 1));
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity, 1));
}
.text-lime-500{
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity, 1));
}
.text-lime-700{
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity, 1));
}
.text-lime-800{
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity, 1));
}
.text-lime-900{
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity, 1));
}
.text-neutral-700{
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity, 1));
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(231 70 148 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(214 31 105 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(191 18 93 / var(--tw-text-opacity, 1));
}
.text-pink-800{
  --tw-text-opacity: 1;
  color: rgb(153 21 75 / var(--tw-text-opacity, 1));
}
.text-pink-900{
  --tw-text-opacity: 1;
  color: rgb(117 26 61 / var(--tw-text-opacity, 1));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(144 97 249 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(108 43 217 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(200 30 30 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(155 28 28 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(119 29 29 / var(--tw-text-opacity, 1));
}
.text-teal-500{
  --tw-text-opacity: 1;
  color: rgb(6 148 162 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(3 102 114 / var(--tw-text-opacity, 1));
}
.text-teal-800{
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity, 1));
}
.text-teal-900{
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(227 160 8 / var(--tw-text-opacity, 1));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(194 120 3 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(142 75 16 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity, 1));
}
.text-yellow-900{
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.placeholder-cyan-700::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(14 116 144 / var(--tw-placeholder-opacity, 1));
}
.placeholder-green-700::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(4 108 78 / var(--tw-placeholder-opacity, 1));
}
.placeholder-red-700::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(200 30 30 / var(--tw-placeholder-opacity, 1));
}
.placeholder-yellow-700::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(142 75 16 / var(--tw-placeholder-opacity, 1));
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.mix-blend-lighten{
  mix-blend-mode: lighten;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-0{
  outline-width: 0px;
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-cyan-400{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity, 1));
}
.ring-cyan-700{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity, 1));
}
.ring-gray-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.ring-gray-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
.ring-gray-800{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}
.ring-green-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}
.ring-pink-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 70 148 / var(--tw-ring-opacity, 1));
}
.ring-purple-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 97 249 / var(--tw-ring-opacity, 1));
}
.ring-red-500{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-yellow-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity, 1));
}
.ring-opacity-5{
  --tw-ring-opacity: 0.05;
}
.drop-shadow-2xl{
  --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia{
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\2c border-color\\2c text-decoration-color\\2c fill\\2c stroke\\2c box-shadow\\]{
  transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-0{
  transition-delay: 0s;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.duration-75{
  transition-duration: 75ms;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[overflow\\:-moz-scrollbars-none\\]{
  overflow: -moz-scrollbars-none;
}
.\\[scrollbar-width\\:none\\]{
  scrollbar-width: none;
}
.file\\:-mx-3::file-selector-button{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.file\\:-my-\\[0\\.32rem\\]::file-selector-button{
  margin-top: -0.32rem;
  margin-bottom: -0.32rem;
}
.file\\:overflow-hidden::file-selector-button{
  overflow: hidden;
}
.file\\:rounded-none::file-selector-button{
  border-radius: 0px;
}
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:border-solid::file-selector-button{
  border-style: solid;
}
.file\\:border-inherit::file-selector-button{
  border-color: inherit;
}
.file\\:bg-neutral-100::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.file\\:px-3::file-selector-button{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:py-\\[0\\.32rem\\]::file-selector-button{
  padding-top: 0.32rem;
  padding-bottom: 0.32rem;
}
.file\\:text-neutral-700::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity, 1));
}
.file\\:transition::file-selector-button{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.file\\:duration-150::file-selector-button{
  transition-duration: 150ms;
}
.file\\:ease-in-out::file-selector-button{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.file\\:\\[border-inline-end-width\\:1px\\]::file-selector-button{
  border-inline-end-width: 1px;
}
.file\\:\\[margin-inline-end\\:0\\.75rem\\]::file-selector-button{
  margin-inline-end: 0.75rem;
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:left-\\[2px\\]::after{
  content: var(--tw-content);
  left: 2px;
}
.after\\:left-\\[4px\\]::after{
  content: var(--tw-content);
  left: 4px;
}
.after\\:start-\\[2px\\]::after{
  content: var(--tw-content);
  inset-inline-start: 2px;
}
.after\\:top-0\\.5::after{
  content: var(--tw-content);
  top: 0.125rem;
}
.after\\:top-\\[1px\\]::after{
  content: var(--tw-content);
  top: 1px;
}
.after\\:top-\\[2px\\]::after{
  content: var(--tw-content);
  top: 2px;
}
.after\\:h-4::after{
  content: var(--tw-content);
  height: 1rem;
}
.after\\:h-5::after{
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:h-6::after{
  content: var(--tw-content);
  height: 1.5rem;
}
.after\\:w-4::after{
  content: var(--tw-content);
  width: 1rem;
}
.after\\:w-5::after{
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:w-6::after{
  content: var(--tw-content);
  width: 1.5rem;
}
.after\\:translate-x-full::after{
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rounded-full::after{
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border::after{
  content: var(--tw-content);
  border-width: 1px;
}
.after\\:border-gray-300::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.after\\:border-white::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.after\\:bg-\\[\\#8138df66\\]::after{
  content: var(--tw-content);
  background-color: #8138df66;
}
.after\\:transition-all::after{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after{
  --tw-content: '';
  content: var(--tw-content);
}
.first\\:ml-0:first-child{
  margin-left: 0px;
}
.first\\:mt-0:first-child{
  margin-top: 0px;
}
.first\\:rounded-t-lg:first-child{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.first\\:border-t-0:first-child{
  border-top-width: 0px;
}
.first\\:pt-0:first-child{
  padding-top: 0px;
}
.last\\:mr-0:last-child{
  margin-right: 0px;
}
.last\\:rounded-b-lg:last-child{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.odd\\:bg-white:nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.even\\:bg-gray-50:nth-child(even){
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:cursor-not-allowed:hover{
  cursor: not-allowed;
}
.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#10B981\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2E5528\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(46 85 40 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#60855B\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(96 133 91 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-lime-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-pink-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-opacity-75:hover{
  --tw-bg-opacity: 0.75;
}
.hover\\:bg-gradient-to-br:hover{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.hover\\:text-\\[\\#1c1c2c\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(28 28 44 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-700:hover{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:file\\:bg-neutral-200::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
}
.focus\\:z-10:focus{
  z-index: 10;
}
.focus\\:\\!border-\\[\\#1c1c2c\\]:focus{
  --tw-border-opacity: 1 !important;
  border-color: rgb(28 28 44 / var(--tw-border-opacity, 1)) !important;
}
.focus\\:border-blue-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(28 100 242 / var(--tw-border-opacity, 1));
}
.focus\\:border-cyan-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.focus\\:border-green-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}
.focus\\:border-green-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity, 1));
}
.focus\\:border-red-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}
.focus\\:border-red-600:focus{
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity, 1));
}
.focus\\:border-yellow-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity, 1));
}
.focus\\:bg-gray-100:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-gray-300:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.focus\\:text-blue-900:focus{
  --tw-text-opacity: 1;
  color: rgb(35 56 118 / var(--tw-text-opacity, 1));
}
.focus\\:text-cyan-700:focus{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.focus\\:text-gray-900:focus{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.focus\\:text-neutral-700:focus{
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity, 1));
}
.focus\\:\\!shadow-none:focus{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-blue-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(164 202 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(118 169 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(28 100 242 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(103 232 249 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 145 178 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-700:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-800:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-gray-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-gray-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-gray-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-gray-800:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-gray-900:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 240 218 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(132 225 188 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 141 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-800:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(180 198 252 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(141 162 251 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-700:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-lime-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 249 157 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-lime-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(190 242 100 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-lime-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(163 230 53 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-lime-700:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 124 15 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pink-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 209 232 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pink-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 180 217 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pink-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 126 184 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pink-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 31 105 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 215 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(202 191 253 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(172 148 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 232 232 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 180 180 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 36 36 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-900:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 29 29 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-teal-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 220 226 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-teal-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 189 202 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-teal-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-yellow-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-yellow-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-yellow-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity, 1));
}
.active\\:bg-blue-100:active{
  --tw-bg-opacity: 1;
  background-color: rgb(225 239 254 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-blue-800:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-cyan-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-cyan-800:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-gray-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-gray-900:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-green-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-green-800:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(3 84 63 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-indigo-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-lime-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-pink-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 243 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-purple-800:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(85 33 181 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-red-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-red-800:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(155 28 28 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-teal-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-yellow-100:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-yellow-500:hover:enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:bg-gradient-to-bl:hover:enabled{
  background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));
}
.enabled\\:hover\\:bg-gradient-to-br:hover:enabled{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.enabled\\:hover\\:bg-gradient-to-l:hover:enabled{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.enabled\\:hover\\:from-teal-200:hover:enabled{
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.enabled\\:hover\\:to-lime-200:hover:enabled{
  --tw-gradient-to: #d9f99d var(--tw-gradient-to-position);
}
.enabled\\:hover\\:text-cyan-700:hover:enabled{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.enabled\\:hover\\:text-gray-700:hover:enabled{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.enabled\\:hover\\:text-gray-900:hover:enabled{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:text-gray-400:disabled{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.group:first-child .group-first\\:hidden{
  display: none;
}
.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:first\\:rounded-tl-lg:first-child{
  border-top-left-radius: 0.5rem;
}
.group\\/head:first-child .group-first\\/head\\:first\\:rounded-tl-lg:first-child{
  border-top-left-radius: 0.5rem;
}
.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:last\\:rounded-tr-lg:last-child{
  border-top-right-radius: 0.5rem;
}
.group\\/head:first-child .group-first\\/head\\:last\\:rounded-tr-lg:last-child{
  border-top-right-radius: 0.5rem;
}
.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:first\\:rounded-bl-lg:first-child{
  border-bottom-left-radius: 0.5rem;
}
.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:last\\:rounded-br-lg:last-child{
  border-bottom-right-radius: 0.5rem;
}
.group:hover .group-hover\\:block{
  display: block;
}
.group:hover .group-hover\\:bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-cyan-200{
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-indigo-200{
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-lime-200{
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-pink-200{
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-purple-200{
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-red-200{
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-teal-200{
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.group:hover .group-hover\\:bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.group:focus .group-focus\\:outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.group:focus .group-focus\\:ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.group:focus .group-focus\\:ring-cyan-500\\/25{
  --tw-ring-color: rgb(6 182 212 / 0.25);
}
.group:focus .group-focus\\:ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.group:enabled:hover .group-enabled\\:group-hover\\:bg-opacity-0{
  --tw-bg-opacity: 0;
}
.group:enabled:hover .group-enabled\\:group-hover\\:text-inherit{
  color: inherit;
}
.group.active .group-\\[\\&\\.active\\]\\:rounded-bl-full{
  border-bottom-left-radius: 9999px;
}
.group.active .group-\\[\\&\\.active\\]\\:rounded-tl-full{
  border-top-left-radius: 9999px;
}
.group.active .group-\\[\\&\\.active\\]\\:bg-\\[\\#60855B\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(96 133 91 / var(--tw-bg-opacity, 1));
}
.group.active .group-\\[\\&\\.active\\]\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-\\[\\#1c1c2c\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 44 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after{
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:after\\:border-white::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.peer:checked ~ .peer-checked\\:after\\:bg-white::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-1\\/2{
  top: 50%;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:left-0{
  left: 0px;
}
.peer:focus ~ .peer-focus\\:top-2{
  top: 0.5rem;
}
.peer:focus ~ .peer-focus\\:-translate-y-4{
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:-translate-y-6{
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:scale-75{
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.peer:focus ~ .peer-focus\\:text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity, 1));
}
.peer:focus ~ .peer-focus\\:outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.dark\\:block:is(.dark *){
  display: block;
}
.dark\\:hidden:is(.dark *){
  display: none;
}
.dark\\:divide-gray-700:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-divide-opacity, 1));
}
.dark\\:border-none:is(.dark *){
  border-style: none;
}
.dark\\:border-cyan-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.dark\\:border-cyan-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.dark\\:border-cyan-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-700:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-800:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(49 196 141 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity, 1));
}
.dark\\:border-indigo-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(88 80 236 / var(--tw-border-opacity, 1));
}
.dark\\:border-lime-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity, 1));
}
.dark\\:border-neutral-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / var(--tw-border-opacity, 1));
}
.dark\\:border-pink-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(214 31 105 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(249 128 128 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity, 1));
}
.dark\\:border-teal-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(4 116 129 / var(--tw-border-opacity, 1));
}
.dark\\:border-white:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.dark\\:border-yellow-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity, 1));
}
.dark\\:border-yellow-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity, 1));
}
.dark\\:\\!bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1)) !important;
}
.dark\\:bg-black:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(28 100 242 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-cyan-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-cyan-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-cyan-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-cyan-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-800\\/30:is(.dark *){
  background-color: rgb(31 41 55 / 0.3);
}
.dark\\:bg-gray-800\\/50:is(.dark *){
  background-color: rgb(31 41 55 / 0.5);
}
.dark\\:bg-gray-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(1 71 55 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-indigo-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-indigo-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-indigo-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-lime-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-lime-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-pink-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-pink-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 105 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-purple-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-purple-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-purple-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-purple-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(74 29 150 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(224 36 36 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(119 29 29 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-teal-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-teal-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-transparent:is(.dark *){
  background-color: transparent;
}
.dark\\:bg-yellow-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-yellow-200:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-yellow-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-yellow-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(99 49 18 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-opacity-80:is(.dark *){
  --tw-bg-opacity: 0.8;
}
.dark\\:fill-gray-300:is(.dark *){
  fill: #D1D5DB;
}
.dark\\:text-blue-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(30 66 159 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(35 56 118 / var(--tw-text-opacity, 1));
}
.dark\\:text-cyan-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-cyan-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.dark\\:text-cyan-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.dark\\:text-cyan-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.dark\\:text-cyan-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.dark\\:text-cyan-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(49 196 141 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(88 80 236 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity, 1));
}
.dark\\:text-lime-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity, 1));
}
.dark\\:text-lime-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity, 1));
}
.dark\\:text-lime-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity, 1));
}
.dark\\:text-neutral-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}
.dark\\:text-pink-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(214 31 105 / var(--tw-text-opacity, 1));
}
.dark\\:text-pink-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(153 21 75 / var(--tw-text-opacity, 1));
}
.dark\\:text-pink-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(117 26 61 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(74 29 150 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(249 128 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(155 28 28 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(119 29 29 / var(--tw-text-opacity, 1));
}
.dark\\:text-teal-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity, 1));
}
.dark\\:text-teal-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity, 1));
}
.dark\\:text-teal-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity, 1));
}
.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(159 88 10 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-800:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-900:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder-gray-400:is(.dark *)::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.dark\\:mix-blend-color:is(.dark *){
  mix-blend-mode: color;
}
.dark\\:shadow-sm-light:is(.dark *){
  --tw-shadow: 0 2px 5px 0px rgba(255, 255, 255, 0.08);
  --tw-shadow-colored: 0 2px 5px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:ring-cyan-800:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-gray-400:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-gray-500:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-gray-800:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-gray-900:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-green-500:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-pink-500:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 70 148 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-purple-600:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-red-700:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(200 30 30 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-yellow-500:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-offset-blue-700:is(.dark *){
  --tw-ring-offset-color: #1A56DB;
}
.dark\\:ring-offset-cyan-600:is(.dark *){
  --tw-ring-offset-color: #0891b2;
}
.dark\\:ring-offset-gray-800:is(.dark *){
  --tw-ring-offset-color: #1F2937;
}
.dark\\:ring-offset-gray-900:is(.dark *){
  --tw-ring-offset-color: #111827;
}
.dark\\:ring-offset-green-600:is(.dark *){
  --tw-ring-offset-color: #057A55;
}
.dark\\:ring-offset-green-800:is(.dark *){
  --tw-ring-offset-color: #03543F;
}
.dark\\:ring-offset-indigo-700:is(.dark *){
  --tw-ring-offset-color: #5145CD;
}
.dark\\:ring-offset-lime-700:is(.dark *){
  --tw-ring-offset-color: #4d7c0f;
}
.dark\\:ring-offset-pink-600:is(.dark *){
  --tw-ring-offset-color: #D61F69;
}
.dark\\:ring-offset-purple-600:is(.dark *){
  --tw-ring-offset-color: #7E3AF2;
}
.dark\\:ring-offset-red-600:is(.dark *){
  --tw-ring-offset-color: #E02424;
}
.dark\\:ring-offset-red-900:is(.dark *){
  --tw-ring-offset-color: #771D1D;
}
.dark\\:ring-offset-teal-600:is(.dark *){
  --tw-ring-offset-color: #047481;
}
.dark\\:ring-offset-yellow-400:is(.dark *){
  --tw-ring-offset-color: #E3A008;
}
.dark\\:file\\:bg-neutral-700:is(.dark *)::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity, 1));
}
.dark\\:file\\:text-neutral-100:is(.dark *)::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.odd\\:dark\\:bg-gray-800:is(.dark *):nth-child(odd){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.even\\:dark\\:bg-gray-700:is(.dark *):nth-child(even){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-blue-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-blue-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-cyan-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-cyan-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-600:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-700:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-800:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-green-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-indigo-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-lime-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-pink-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 217 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-purple-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-red-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 180 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-teal-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-yellow-300:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:text-gray-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:focus\\:border-blue-500:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:border-cyan-500:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:border-green-500:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:border-red-500:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:border-yellow-500:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:bg-cyan-600:focus:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.dark\\:focus\\:bg-gray-600:focus:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:focus\\:text-white:focus:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:focus\\:ring-blue-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(26 86 219 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-blue-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 66 159 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-cyan-500:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-cyan-600:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 145 178 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-cyan-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-cyan-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-gray-500:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-gray-600:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-gray-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 65 81 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-gray-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-gray-900:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-green-500:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-green-600:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-green-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 108 78 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-green-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-indigo-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-lime-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 124 15 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-lime-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 98 18 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-pink-600:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 31 105 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-pink-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 18 93 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-pink-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 21 75 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-purple-600:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-purple-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(85 33 181 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-purple-900:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 29 150 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-red-400:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-red-500:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-red-600:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 36 36 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-red-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(200 30 30 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-red-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(155 28 28 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-red-900:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 29 29 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-teal-600:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-teal-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 102 114 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-teal-800:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 80 92 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-yellow-400:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-yellow-500:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-yellow-700:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(142 75 16 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-yellow-900:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 49 18 / var(--tw-ring-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-cyan-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-gray-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-green-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-indigo-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(81 69 205 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-lime-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-pink-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(191 18 93 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-red-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(200 30 30 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-teal-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(3 102 114 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:border-yellow-700:hover:enabled:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(142 75 16 / var(--tw-border-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-cyan-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-gray-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-green-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-indigo-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(81 69 205 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-lime-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-pink-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(191 18 93 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-purple-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-red-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(200 30 30 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-teal-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(3 102 114 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:bg-yellow-700:hover:enabled:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(142 75 16 / var(--tw-bg-opacity, 1));
}
.enabled\\:dark\\:hover\\:bg-gray-700:hover:is(.dark *):enabled{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:enabled\\:hover\\:text-white:hover:enabled:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.enabled\\:dark\\:hover\\:text-white:hover:is(.dark *):enabled{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.disabled\\:dark\\:text-gray-500:is(.dark *):disabled{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-blue-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-cyan-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-gray-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-gray-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-gray-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-gray-800\\/60:is(.dark *){
  background-color: rgb(31 41 55 / 0.6);
}
.group:hover .dark\\:group-hover\\:bg-green-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-indigo-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-lime-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-pink-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 217 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-purple-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-red-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 180 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-teal-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:bg-yellow-300:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:focus .dark\\:group-focus\\:ring-gray-800\\/70:is(.dark *){
  --tw-ring-color: rgb(31 41 55 / 0.7);
}
.peer:focus ~ .peer-focus\\:dark\\:text-blue-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity, 1));
}
@media (max-width: 1800px){
  .max-\\[1800px\\]\\:w-full{
    width: 100%;
  }
}
@media (min-width: 560px){
  .sm\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .sm\\:mb-0{
    margin-bottom: 0px;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:h-10{
    height: 2.5rem;
  }
  .sm\\:h-6{
    height: 1.5rem;
  }
  .sm\\:h-7{
    height: 1.75rem;
  }
  .sm\\:w-10{
    width: 2.5rem;
  }
  .sm\\:w-6{
    width: 1.5rem;
  }
  .sm\\:w-\\[150px\\]{
    width: 150px;
  }
  .sm\\:min-w-\\[400px\\]{
    min-width: 400px;
  }
  .sm\\:max-w-\\[600px\\]{
    max-width: 600px;
  }
  .sm\\:max-w-\\[80\\%\\]{
    max-width: 80%;
  }
  .sm\\:rounded-md{
    border-radius: 0.375rem;
  }
  .sm\\:border{
    border-width: 1px;
  }
  .sm\\:border-gray-300{
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  }
  .sm\\:p-\\[40px\\]{
    padding: 40px;
  }
  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:pr-8{
    padding-right: 2rem;
  }
  .sm\\:text-center{
    text-align: center;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .sm\\:shadow-md{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 767px){
  .md\\:inset-0{
    inset: 0px;
  }
  .md\\:mx-2{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .md\\:mr-6{
    margin-right: 1.5rem;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-32{
    height: 8rem;
  }
  .md\\:h-5{
    height: 1.25rem;
  }
  .md\\:h-auto{
    height: auto;
  }
  .md\\:h-full{
    height: 100%;
  }
  .md\\:w-32{
    width: 8rem;
  }
  .md\\:w-48{
    width: 12rem;
  }
  .md\\:w-5{
    width: 1.25rem;
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:max-w-xl{
    max-width: 36rem;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-between{
    justify-content: space-between;
  }
  .md\\:space-x-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:rounded-none{
    border-radius: 0px;
  }
  .md\\:rounded-l-lg{
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }
  .md\\:border-0{
    border-width: 0px;
  }
  .md\\:bg-transparent{
    background-color: transparent;
  }
  .md\\:p-0{
    padding: 0px;
  }
  .md\\:px-\\[70px\\]{
    padding-left: 70px;
    padding-right: 70px;
  }
  .md\\:py-\\[80px\\]{
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .md\\:font-medium{
    font-weight: 500;
  }
  .md\\:text-cyan-700{
    --tw-text-opacity: 1;
    color: rgb(14 116 144 / var(--tw-text-opacity, 1));
  }
  .md\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }
  .md\\:hover\\:text-cyan-700:hover{
    --tw-text-opacity: 1;
    color: rgb(14 116 144 / var(--tw-text-opacity, 1));
  }
  .md\\:dark\\:hover\\:bg-transparent:hover:is(.dark *){
    background-color: transparent;
  }
  .md\\:dark\\:hover\\:text-white:hover:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
@media (min-width: 1024px){
  .lg\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .lg\\:px-\\[155px\\]{
    padding-left: 155px;
    padding-right: 155px;
  }
}
@media (min-width: 1440px){
  .xl\\:px-\\[255px\\]{
    padding-left: 255px;
    padding-right: 255px;
  }
  .xl\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
.peer:checked ~ .rtl\\:peer-checked\\:after\\:-translate-x-full:where([dir="rtl"], [dir="rtl"] *)::after{
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!hidden::-webkit-scrollbar{
  display: none !important;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!h-0::-webkit-scrollbar{
  height: 0px !important;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!w-0::-webkit-scrollbar{
  width: 0px !important;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!bg-transparent::-webkit-scrollbar{
  background-color: transparent !important;
}
.\\[\\&\\>\\*\\]\\:pointer-events-none>*{
  pointer-events: none;
}
.\\[\\&\\>\\*\\]\\:cursor-grab>*{
  cursor: grab;
}
.\\[\\&\\>\\*\\]\\:first\\:rounded-t-lg:first-child>*{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.\\[\\&\\>\\*\\]\\:last\\:rounded-b-lg:last-child>*{
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.\\[\\&\\>\\*\\]\\:last\\:border-b-0:last-child>*{
  border-bottom-width: 0px;
}
.\\[\\&_\\.ml-auto\\]\\:\\!hidden .ml-auto{
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,yCAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,wCAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,8BAAc;EAAd,yBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,mBAAc;EAAd,eAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,0BAAc;EAAd,uBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,YAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA,WAAc;EAAd,kBAAc;EAAd,aAAc;EAAd,cAAc;EAAd,iBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,cAAc;EAAd,wHAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,4BAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA1BnB;EAAA,qBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,qBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,wJA2BA;EA3BA,wDA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA,wBA2BA;EA3BA,wDA2BA;EA3BA;AA2BA;AA3BA;EAAA,gBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,8BA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kCA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,gFA2BA;EA3BA,oGA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,iCA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,iCA2BA;EA3BA,yCA2BA;EA3BA;AA2BA;AA3BA;EAAA,8BA2BA;EA3BA;AA2BA;AA3BA;EAAA,2GA2BA;EA3BA,yGA2BA;EA3BA;AA2BA;AA3BA;EAAA,2GA2BA;EA3BA,yGA2BA;EA3BA;AA2BA;AA3BA;EAAA,2GA2BA;EA3BA,yGA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,4DA2BA;EA3BA,qEA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,8BA2BA;EA3BA;AA2BA;AA3BA;EAAA,2GA2BA;EA3BA,yGA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,0BA2BA;EA3BA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,qBA2BA;EA3BA;AA2BA;AA3BA;EAAA,eA2BA;EA3BA,eA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,uBA2BA;EA3BA;AA2BA;AA3BA;EAAA,yBA2BA;EA3BA;AA2BA;AA3BA;EAAA,iBA2BA;EA3BA,iBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,8BA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,6BA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,2BA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,oDA2BA;EA3BA,yDA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,sBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,kBA2BA;EA3BA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,oBA2BA;EA3BA;AA2BA;AA3BA;EAAA;IAAA;EA2BA;AAAA;AA3BA;EAAA;IAAA,iBA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,sBA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,kBA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,kBA2BA;IA3BA;EA2BA;EA3BA;IAAA,6EA2BA;IA3BA,iGA2BA;IA3BA;EA2BA;AAAA;AA3BA;EAAA;IAAA;EA2BA;EA3BA;IAAA,mBA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,uBA2BA;IA3BA,oDA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,8BA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,kBA2BA;IA3BA;EA2BA;EA3BA;IAAA,iBA2BA;IA3BA;EA2BA;EA3BA;IAAA,eA2BA;IA3BA;EA2BA;EA3BA;IAAA,mBA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,oBA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,oBA2BA;IA3BA;EA2BA;EA3BA;IAAA;EA2BA;EA3BA;IAAA,oBA2BA;IA3BA;EA2BA;AAAA;AA3BA;EAAA;IAAA,gBA2BA;IA3BA;EA2BA;EA3BA;IAAA,mBA2BA;IA3BA;EA2BA;AAAA;AA3BA;EAAA;IAAA,mBA2BA;IA3BA;EA2BA;EA3BA;IAAA,kBA2BA;IA3BA;EA2BA;AAAA;AA3BA;EAAA,0BA2BA;EA3BA,uBA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA,8BA2BA;EA3BA;AA2BA;AA3BA;EAAA,kCA2BA;EA3BA;AA2BA;AA3BA;EAAA;AA2BA;AA3BA;EAAA;AA2BA","sourcesContent":["@import \"./assets/fonts/stylesheet.css\";\nbody {\n  margin: 0;\n  font-family: \"Lato\", \"Roboto\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.stylish-scroll::-webkit-scrollbar {\n  width: 5px;\n}\n\n.stylish-scroll::-webkit-scrollbar-track {\n  background-color: transparent !important;\n  border-radius: 100px;\n}\n\n.stylish-scroll::-webkit-scrollbar-thumb {\n  border-radius: 100px;\n  border: 5px solid transparent;\n  background-clip: content-box;\n  background: rgba(129, 56, 223, 0.2);\n}\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
